import axios from  'axios' ;

    export const getPlayerStats = (idPlayer,callback) => {
      let url = process.env.REACT_APP_API2_URL + '/Player/Player_GetStatistics?idPlayer='+idPlayer;
   
      callback && axios
        .get(url)
        .then((response) => { 
          console.log("", response)
          callback(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    
    export const getEntityById = (id, entity, idName, callback) => {
      let url = process.env.REACT_APP_API_URL + '/'+entity+'?filter='+idName+',eq,'+id;
   
      callback && axios
        .get(url)
        .then((response) => { 
          callback(response.data.records[0]);
        })
        .catch((error) => {
          console.log(error);
        });
    };

   